import { render, staticRenderFns } from "./trilhas-on-parques.vue?vue&type=template&id=5bea71a2"
import script from "./trilhas-on-parques.vue?vue&type=script&lang=js"
export * from "./trilhas-on-parques.vue?vue&type=script&lang=js"
import style0 from "./trilhas-on-parques.vue?vue&type=style&index=0&id=5bea71a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports